import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { RoutePaths } from "../../../../utils/Items";
import "./Sidebar.css";
import NavItem from "./NavItem";
import { useDispatch } from "react-redux";
import { useTranslation } from "../../../../hooks/useTranslation";
import { logout } from "../../../../redux/actions/authActions";
import DialogConfirmation from "../Dialog/DialogConfirmation";
import { PowerSettingsNew } from "@material-ui/icons";

export const AVAILABLE_ROUTES = [
  {
    label: "Inicio",
    href: RoutePaths.LogisticParkHome,
    icon: <HomeIcon />,
  },
  {
    label: "Registro de ingreso",
    href: RoutePaths.LogisticParkEntryRegistration,
    icon: <SwapHorizIcon />,
  },
  // {
  //   label: "Historial",
  //   href: "/lp/historial",
  //   icon: <HistoryIcon />,
  // },
  {
    label: "Salidas",
    href: RoutePaths.LogisticParkExitUsers,
    icon: <ExitToAppIcon />,
  },
  {
    label: "Cerrar sesión",
    icon: <PowerSettingsNew />,
    isLogout: true,
  },
];

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(location.pathname === RoutePaths.LogisticParkHome);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const dispatch = useDispatch();
  const { t, BundleKey } = useTranslation();

  useEffect(() => {
    if (location.pathname === RoutePaths.LogisticParkHome) {
      setCollapsed(true);
    }
  }, [location.pathname]);

  const handleConfirmLogout = () => {
    dispatch(logout());
    setOpenLogoutDialog(false);
  };

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <div className="header-row">
          {!collapsed ? (
            <div className="logo-title">
              <img src="/fullLogo.svg" alt="full-Logo" />
            </div>
          ) : (
            <div className="logo-mini">
              <img src="/logo.svg" alt="Logo" />
            </div>
          )}
          <div className="toggle-btn" onClick={() => setCollapsed((prev) => !prev)}>
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </div>
        </div>
      </div>
      <div className="sidebar-divider" />
      <div className="sidebar-menu">
        <NavItem
          collapsed={collapsed}
          icon={<HomeIcon />}
          label="Inicio"
          href={RoutePaths.LogisticParkHome}
        />
        {/* <NavItem
          collapsed={collapsed}
          icon={<SwapHorizIcon />}
          label="Registro de ingreso"
          href={RoutePaths.LogisticParkEntryRegistration}
        /> */}
        {/* <NavItem
          collapsed={collapsed}
          icon={<HistoryIcon />}
          label="Historial"
          href="/lp/historial"
        /> */}
        <NavItem
          collapsed={collapsed}
          icon={<ExitToAppIcon />}
          label="Salidas"
          href={RoutePaths.LogisticParkExitUsers}
        />
      </div>
      <div className="sidebar-footer">
        <div className="sidebar-divider" />
        <NavItem
          collapsed={collapsed}
          icon={<PowerSettingsNew />}
          label={t(BundleKey.LOGOUT_TITLE)}
          onClick={() => setOpenLogoutDialog(true)}
        />
      </div>
      <DialogConfirmation
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        onConfirm={handleConfirmLogout}
        title={t(BundleKey.LOGOUT_TITLE)}
        message={t(BundleKey.LOGOUT_MESSAGE)}
        confirmLabel={t(BundleKey.ACTION_YES)}
        cancelLabel={t(BundleKey.ACTION_NO)}
      />
    </div>
  );
};

export default Sidebar;
